import { useMemo } from 'react';
import type { FC } from 'react';
import { Flex } from '@chakra-ui/react';
import { useIntl } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';
import { Text } from '../../../../ui-components';
import { BloomreachProductType } from '../../hooks/use-search';
import type { UseSearchResult } from '../../hooks/use-search';

interface SearchListingNoResultsProps {
    id: string;
    search: UseSearchResult;
}

const PRODUCT_TYPE_MESSAGES: Record<BloomreachProductType, MessageDescriptor> = {
    [BloomreachProductType.hardgood]: {
        id: 'No Product Results found for "{query}"',
        defaultMessage: 'No Product Results found for "{query}"',
    },
    [BloomreachProductType.culinary]: {
        id: 'No Cooking Class Results found for "{query}"',
        defaultMessage: 'No Cooking Class Results found for "{query}"',
    },
    [BloomreachProductType.recipe]: {
        id: 'No Recipe Results found for "{query}"',
        defaultMessage: 'No Recipe Results found for "{query}"',
    },
};

export const SearchListingNoResults: FC<SearchListingNoResultsProps> = ({ id, search }) => {
    const intl = useIntl();
    const noResultsMessage = useMemo<string>(
        () =>
            intl.formatMessage(PRODUCT_TYPE_MESSAGES[search.productType], {
                query: search.searchParams?.q ?? '',
            }),
        [intl, search.productType, search.searchParams?.q],
    );
    return (
        <Flex
            data-testid={`empty-product-container-${id}`}
            direction="column"
            align="center"
            justify="center"
            paddingTop={8}
            paddingX={{ base: 4, sm: 0 }}
        >
            <Text id="search.no.results.match.filters" align="center">
                {noResultsMessage}
            </Text>
        </Flex>
    );
};
